import { Goal, GoalProgressCount } from '@griply/types';

import { getCompletionPercentage } from '../get-completion-percentage';
import { isSubGoalMeasuredMetricId } from './derived-metric-ids';
import { isTaskMeasuredGoal } from './is-task-measured-goal';

export type SubGoalProgressState = {
  isCompleted: boolean;
  taskCount?: GoalProgressCount;
  metricValue?: number;
};

export const getSubGoalProgressPercentage = (
  subGoal: Goal,
  { isCompleted, taskCount, metricValue }: SubGoalProgressState,
): number => {
  if (isCompleted) {
    return 100;
  }

  if (isTaskMeasuredGoal(subGoal)) {
    return getCompletionPercentage({
      current: taskCount?.completed ?? 0,
      end: taskCount?.total ?? 0,
    });
  }

  const { metric } = subGoal;
  if (!metric?.id || isSubGoalMeasuredMetricId(metric.id)) {
    return 0;
  }

  const start = metric.startValue ?? 0;

  return getCompletionPercentage({
    start,
    current: metricValue ?? start,
    end: metric.targetValue ?? Infinity,
  });
};

// In sub-goal units: every sub-goal adds between 0 and 1.
export const sumSubGoalProgress = (
  subGoals: Goal[],
  getState: (subGoal: Goal) => SubGoalProgressState,
): number =>
  subGoals.reduce(
    (sum, subGoal) =>
      sum + getSubGoalProgressPercentage(subGoal, getState(subGoal)),
    0,
  ) / 100;
